//          ⢠⣿⣋⣿⣿⣉⣿⣿⣯⣧⡰               
//          ⣿⣿⣹⣿⣿⣏⣿⣿⡗⣿⣿               
//          ⠟⡛⣉⣭⣭⣭⠌⠛⡻⢿⣿               
//          ⠄⠄⣤⡌⣿⣷⣯⣭⣿⡆⣈                
//           ⢻⣿⣿⣿⣿⣿⣿⣿⣷⢛                
//            ⢻⣷⣽⣿⣿⣿⢿⠃⣼⣧⣀              
//              ⣛⣻⣿⠟⣀⡜⣻⢿⣿⣿⣶⣤⡀             
//            ⢠⣤⣀⣨⣥⣾⢟⣧⣿⠸⣿⣿⣿⣿⣿⣤⡀             
//            ⢟⣫⣯⡻⣋⣵⣟⡼⣛⠴⣫⣭⣽⣿⣷⣭⡻⣦⡀     
//           ⢰⣿⣿⣿⢏⣽⣿⢋⣾⡟⢺⣿⣿⣿⣿⣿⣿⣷⢹⣷⠄
//           ⣿⣿⣿⢣⣿⣿⣿⢸⣿⡇⣾⣿⠏⠉⣿⣿⣿⡇⣿⣿⡆
//           ⣿⣿⣿⢸⣿⣿⣿⠸⣿⡇⣿⣿⡆⣼⣿⣿⣿⡇⣿⣿⡇
//           ⠘⣿⣿⡘⣿⣿⣷⢀⣿⣷⣿⣿⡿⠿⢿⣿⣿⡇⣩⣿⡇
// ⣿⣿⠃        ⢻⣷⠙⠛⠋⣿⣿⣿⣿⣿⣷⣶⣿⣿⣿⡇⣿⣿⡇
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from 'vue-meta';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(VueMeta);
Vue.use(ElementUI);
import {
  Breadcrumb,
  Upload,
  Button,
  Icon,
  message,
  Avatar,
  Table,
  DatePicker,
  Tree,
  Card,
  Modal,
  Input,
  Select,
  Popconfirm,
  Radio,
  Affix,
  Checkbox,
  Tooltip,
  Spin,
  Tabs,
  InputNumber,
  FormModel,
  Cascader,
  Tag,
  Badge,
  Pagination,
  Switch,
  Empty,
  Collapse,
  Descriptions,
  Dropdown,
  Menu,
} from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "@/components/projectShell/seeFormModal.scss";
import "@/components/projectShell/seeFormEnhance.js";
const { Panel } = Collapse;

Vue.use(Breadcrumb);
Vue.use(Upload);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Avatar);
Vue.use(Table);
Vue.use(DatePicker);
Vue.use(Tree);
Vue.use(Card);
Vue.use(Modal);
Vue.use(Input);
Vue.use(Select);
Vue.use(Popconfirm);
Vue.use(Radio);
Vue.use(Affix);
Vue.use(Checkbox);
Vue.use(Tooltip);
Vue.use(Spin);
Vue.use(Tabs);
Vue.use(InputNumber);
Vue.use(FormModel);
Vue.use(Cascader);
Vue.use(Tag);
Vue.use(Badge)
Vue.use(Pagination);
Vue.use(Switch);
Vue.use(Empty);
Vue.use(Collapse);
Vue.use(Descriptions);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.component('a-descriptions-item', Descriptions.Item);
Vue.component('a-collapse-panel', Panel);

import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { LocaleProvider } from "ant-design-vue";
Vue.use(LocaleProvider);
Vue.prototype.$antdLocale = zhCN;

import {nullToEmpty, emptyDatesToNull, emptyToNull} from '@/utils/time';
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$nullToEmpty = nullToEmpty
Vue.prototype.$emptyDatesToNull = emptyDatesToNull
Vue.prototype.$emptyToNull = emptyToNull
Vue.config.productionTip = false;
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
Vue.use(Highcharts)
Vue.use(HighchartsVue);
import highcharts3d from 'highcharts/highcharts-3d'
highcharts3d(Highcharts)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
